export default [
	{
		title: '感言入口',
		name: 'entry'
	}, {
		title: '感言详情',
		name: 'detail'
	}, {
		title: '感言列表',
		name: 'timonialsList',
	}, {
		title: '精选感言',
		name: 'chosen'
	},
	{
		title: '我的感言',
		name: 'my-timonials'
	},
]



// WEBPACK FOOTER //
// ./src/route/timonialsRouter.js